export default __webpack_public_path__ + "static/top-pic-04-73a4335700f2846ceeac8f55f75ce09f.png";